<template>
  <div :class="className">
    <form @submit.prevent.stop="handleSubmit">
      <div class="header-topbar-search__group">
        <label for="header-search">
          <input
            id="header-search"
            name="header-search"
            type="search"
            :placeholder="$t('message.common.topbar.search.placeholder')"
            v-model="searchValue"
          />
        </label>
        <BaseSubmit clear icon="search" />
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BaseSubmit from '@base/BaseSubmit'
export default {
  name: 'TheHeaderTopbarSearch',
  components: {
    BaseSubmit
  },
  data () {
    return {
      searchValue: ''
    }
  },
  computed: {
    ...mapGetters({
      search: 'filters/getSearch'
    }),
    className () {
      return [
        'header-topbar-search'
      ]
    }
  },
  mounted () {
    this.searchValue = this.search.value
  },
  methods: {
    ...mapActions({
      updateSearch: 'filters/updateSearch'
    }),
    handleSubmit () {
      if (this.searchValue !== '') {
        this.updateSearch({ value: this.searchValue })
        this.$router.push({ name: 'Search Results' })
        this.searchValue = ''
      }
    }
  }
}
</script>

<style lang="scss">
.header-topbar-search{
  @include media("small-medium"){
    display: none;
  }

  height: 100%;

  form{
    height: 100%;
  }

  // Group

  &__group{
    height: 100%;
    display: flex;
    background-color: shade(colors("topbar"), 30%);

    label{
      margin: 0;
      height: 100%;
    }

    input[type="search"]{
      @include media("large"){
        height: 100%;
      }
      background-color: shade(colors("topbar"), 30%);
      color: tint(colors("font"), 30%);
      border: 0;
      margin: 0;
      box-sizing: border-box;
      width: 20rem;
      font-size: 1.5rem;
    }

    button{
      @include hover{
        .icon{
          color: colors("primary");
        }
      }

      &.has-icon-center{
        padding: 1rem;
      }

      .icon{
        @include add-transition;
        color: tint(colors("font"), 30%);
        font-size: 2rem;
      }
    }
  }
}
</style>
